/**
 * The species catalogue is built from Tata-specific static exports (see ./data), so it is
 * only shown when the active project, site or deployment belongs to Tata.
 */
export const isTataProject = (...names: Array<string | null | undefined>): boolean =>
  names.some((name) => Boolean(name?.toLowerCase().includes('tata')));
